export const PAYMENT_METHODS: any = {
  0: 'DINHEIRO',
  1: 'DÉBITO',
  2: 'CRÉDITO',
  3: 'PIX',
  4: 'FIADO',
  5: 'IFOOD',
  99: 'NÃO DEFINIDO',
};

export const ORDER_STATUS: any = {
  0: 'NOVO PEDIDO',
  1: 'PREPARANDO',
  2: 'SAIU PARA ENTREGA',
  3: 'CONCLUÍDO',
  4: 'CANCELADO',
};

export const NOTIFICATIONS_TYPE: any = {
  0: 'NOVO PEDIDO',
};

export const MONTHS: any = [
  'JANEIRO',
  'FEVEREIRO',
  'MARÇO',
  'ABRIL',
  'MAIO',
  'JUNHO',
  'JULHO',
  'AGOSTO',
  'SETEMBRO',
  'OUTUBRO',
  'NOVEMBRO',
  'DEZEMBRO',
];

export const ORDER_TYPES: any = {
  0: 'Retirar no local',
  1: 'Delivery',
  2: 'Mesa',
};

export const ORDER_TYPES_CONSTS = {
  LOCAL: '0',
  DELIVERY: '1',
  TABLE: '2',
};

export const PRINTER_MODELS = {
  MPT2: '0',
  P_25_BLUE_BAMBOO: '1',
  MOBILE_PRINTER: '2',
};
